import { useContext } from 'react';
import { SampleContext } from '../hoc/SampleProvider';

export function useSample() {
	const context = useContext(SampleContext);
	if (context === null) {
		throw new Error('useSample must be used within a SampleProvider');
	}
	return context;
}
